import { useContext } from 'react';
import { AuthContext } from './AuthContext';
import '../static/modals.scss';
import { useNavigate } from 'react-router-dom';

const LogoutButton = () => {
  const { logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
    navigate('/singin');  // or wherever your login page is
  };

  return <button className='button' onClick={handleLogout}>Logout</button>;
};

export default LogoutButton;


